import React, { useState } from "react";
import { useI18n } from "../../i18n/i18nService";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { usePhoneValidation } from "../../utils/phoneNumber"
import { FlagLanguageSelector } from "../../components/LanguageSelector";
import ThemeToggle from "../../components/ThemeToggle";
import { ButtonCustom, FormError, FormSuccess, InputField } from "../../components/common/Form";

const ForgetPasswordPage = () => {
  const { t, i18n } = useI18n(['auth']);
  const { sendPasswordForgettenRequest, loading } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [phone, setPhone] = useState("");
  const [success, setSuccess] = useState(false);
  const { validate: isValidPhone, format: formatPhone, findDetail } = usePhoneValidation();


  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };


  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    if (!isValidPhone(phone)) {
      setError(t("auth:errors.register.invalid_phone"));
      return;
    }
    try {
      const cleanedPhone = phone.replace(/\s+/g, '');
      await sendPasswordForgettenRequest(cleanedPhone);
      setSuccess(true);
      setTimeout(() => {
        navigate("/otp", { state: { phone: cleanedPhone }, replace: false });
      }, 5000)

    } catch (error) {
      console.log(error);
      setSuccess(false);
      setError(t(`auth:errors.login.${error.status || 500}`));
      return;
    }

  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-light-background dark:bg-dark-background">
      <div className="max-w-md w-full p-6 relative rounded-lg shadow-idaraf dark:shadow-idaraf-dark bg-white dark:bg-gray-800">
        <div className="flex justify-center items-center mb-4">
          <img
            src="/images/logo.png" // Assurez-vous que le chemin est correct
            alt="IDARAF"
            className="h-28 w-28 object-contain rounded-full border border-light-tertiary/20 dark:border-dark-tertiary/20 p-1 dark:bg-gray-50"
          />
        </div>

        {/* 🧩 Formulaire de connexion */}
        {/* <h1 className="text-2xl font-bold mb-6 text-center">{t("login")}</h1> */}
        <form onSubmit={handleSubmit} className="space-y-4">

          <h2 className="text-2xl font-bold mb-6 text-center text-light-text/80 dark:text-dark-text">{t("auth:password_recovery")}</h2>
          {error &&
            <FormError message={error} />
          }
          {success &&
            <FormSuccess message={t("auth:forget_password_success")} />
          }

          <InputField
            name="phone"
            label={t("auth:phone_number")}
            type="text"
            placeholder={t("auth:phone_number_placeholder")}
            autoComplete="username"
            value={phone}
            onChange={(e) => {
              const { value } = e.target;
              const raw = value.replace(/[^\d+]/g, '');
              setPhone(formatPhone(raw));
              console.log(findDetail(raw));
            }}
            required
          />

          <ButtonCustom
            type="submit"
            disabled={loading}
            loading={loading}
            variant="primary"
            className="w-full py-2 px-4 rounded-md text-white font-semibold"
          >
            {t("auth:submit")}
          </ButtonCustom>

          <div className="flex justify-between items-center mt-4">
            <div className="text-sm text-gray-600 dark:text-gray-400  ">
              {t("auth:already_have_an_account")}{" "}
              <a href="/login" className="text-light-primary dark:text-dark-primary hover:underline">
                {t("auth:sign_in")}
              </a>
            </div>
            <ThemeToggle />
          </div>
        </form>
        <div className="absolute top-5 right-5 flex items-center justify-center">
          <FlagLanguageSelector
            currentLanguage={i18n.language}
            onChange={changeLanguage}
          />
        </div>
      </div>
    </div>
  );
};

export default ForgetPasswordPage
